import { Button, Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from '../../../../../components/migrated/modal';
import { IModalLimiteSize } from './interfaces';

import { useStyles } from './styles';

export const ModalPreview = (props: IModalLimiteSize) => {
  const { data, files, open: openProps, onClose, onAccept } = props;
  const [open, setOpen] = useState(true);
  const classes = useStyles();

  console.log(data, files);

  const handleOnClose = () => {
    setOpen(false);
    onClose(false);
  };

  useEffect(() => {
    setOpen(openProps);
  }, [openProps]);

  return (
    <Modal open={open} onClose={handleOnClose} title="RESUMO DAS INFORMAÇÕES">
      <div className={classes.root}>
        <div className={classes.previewInfo}>
          <Typography style={{ marginBottom: '24px' }}>As informações fornecidas estão corretas?</Typography>

          <Typography style={{ marginBottom: '12px' }}>
            <b>Fornecedor:</b> {data.personId.key} - {data.personId.value}
          </Typography>

          <Typography>
            <b>Produto devolvido:</b>
          </Typography>

          <Typography style={{ marginLeft: '24px' }}>
            <b>ID Prod:</b> {data.productId.key}
          </Typography>

          <Typography style={{ marginLeft: '24px' }}>
            <b>Nome do produto:</b> {data.productId.value}
          </Typography>

          <Typography style={{ marginLeft: '24px' }}>
            <b>Divisão:</b> {data.productDivisionName}
          </Typography>

          <Typography style={{ marginLeft: '24px' }}>
            <b>Grupo:</b> {data.productGroupId} - {data.productGroupName}
          </Typography>

          <Typography style={{ marginLeft: '24px' }}>
            <b>Data do recebimento:</b> {moment(data.receiptDate).format('DD/MM/YYYY')}
          </Typography>

          <Typography style={{ marginTop: '12px' }}>
            <b>Descritivo:</b>
          </Typography>

          <Typography style={{ marginLeft: '24px' }}>Quantidade agendada: {data.scheduledQuantity}</Typography>

          <Typography style={{ marginLeft: '24px' }}>Quantidade vistoriada: {data.inspectedQuantity}</Typography>

          <Typography style={{ marginLeft: '24px' }}>Quantidade devolvida: {data.returnedQuantity}</Typography>

          <Typography style={{ marginLeft: '24px' }}>Quantidade estocada: {data.stokedQuantity}</Typography>

          <Typography style={{ marginTop: '12px' }}>
            <b>Motivo da devolução:</b>
          </Typography>
          <>
            {data.returnReceiptReasons.map((reason: any, key: number) => (
              <Typography key={key} style={{ marginLeft: '24px' }}>
                • {reason?.value}
              </Typography>
            ))}
          </>

          <Typography style={{ marginTop: '12px', wordWrap: 'break-word' }}>
            <b>Observação:</b> {data?.noteDescription?.toUpperCase()}
          </Typography>
        </div>

        <Grid container spacing={2} style={{ marginTop: '12px', marginBottom: '12px' }}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.imageContainer}>
              {files.map((upload, key) => (
                <Fragment key={key}>
                  {upload.fileAllowedSize && (
                    <div
                      className={classes.image}
                      style={{
                        backgroundImage: `url(${upload.filePathBase64})`
                      }}
                    ></div>
                  )}
                </Fragment>
              ))}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
            <Button variant="text" color="primary" onClick={handleOnClose} style={{ marginRight: '24px' }}>
              NÃO, EDITAR INFORMAÇÕES
            </Button>

            <Button variant="text" color="primary" onClick={onAccept}>
              SIM, SALVAR
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};
